import { Environment } from './definitions';

// The file contents for the current environment will overwrite these during build.
// The build system defaults to the dev environment which uses `environment.ts`, but if you do
// `ng build --env=prod` then `environment.prod.ts` will be used instead.
// The list of which env maps to which file can be found in `angular.json`.

export const environment = new Environment({
  alias: 'local-calen',
  tenantId: '677A2E52-5F2D-4EBB-BF6D-91E53708C00D',
  pendoApiKey: '9a350745-1d15-47a2-723b-fb6731dec31a',
  enableRouterTracing: false,
  useProxy: false
});
